<template>
  <main contact>
    <div class="inner-wrap">
      <dl>
        <dt>newtype imageworks</dt>
        <dd>
          1F, 21 Gangnam-daero 132-gil,<br>
          Gangnam-gu, Seoul, Republic of Korea.<br>
          06044
        </dd>
      </dl>
      <dl>
        <dt>New business</dt>
        <dd><a href="mailto:hello@newtype.design">hello@newtype.design</a></dd>
      </dl>
      <dl>
        <dt>Jobs</dt>
        <dd><a href="mailto:career@newtype.design">career@newtype.design</a></dd>
      </dl>
    </div>
  </main>
</template>

<script>

export default {
  name: 'contact',
  components: {},
  data() {
    return {
      policy: null,
    };
  },
  methods: {
  },
  mounted() {
    this.$store.commit('theme', 'default');
  },
};
</script>

<style lang="less">
@import "~@/less/proj.less";

[contact] { .pt(130); .space-m; min-height: calc(100vh - 262px); .-box; .fs(16,24);
  .inner-wrap { .rel; }
  dl { .mb(20); &:first-of-type { .mb(60); }}
  dd { color: #828282; }
  a { .underline; }
}

@media (min-width: @screen-tp-min) {
  [contact] { .pt(160); min-height: calc(100vh - 184px);
    dl:first-of-type { .abs; .lt(33%,0); }
    dl { .mb(40); }
  }
}
@media (min-width: @screen-dm-min) {
  [contact] { .pt(200); .space-d; min-height: calc(100vh - 204px); .fs(20,32);
    dl { .mb(60); }
  }
}
@media (min-width: @screen-dx-min) {
  [contact] { .pt(220); min-height: calc(100vh - 248px); .fs(24,40); }
}
//@media (min-width: @screen-dx-min) {
//  [contact] { .pt(240); min-height: calc(100vh - 248px); .fs(34,52); }
//}
</style>
